import { React } from 'react'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/pages/Home';
import Authenticate from './components/pages/Authenticate';
import Library from './components/pages/Library';
import Mantras from './components/pages/Mantras';
import Sutras from './components/pages/Sutras';
import LibraryWorks from './components/pages/LibraryWorks';
import LibraryWork from './components/pages/LibraryWork';
import Mission from './components/pages/Mission';
import Donate from './components/pages/Donate';
import Discord from './components/pages/Discord';
import Contact from './components/pages/Contact';
import Calendar from './components/pages/Calendar';
import Admin from './components/pages/Admin';
import Blog from './components/pages/Blog';
import BlogPost from './components/pages/BlogPost';
import BlogCategory from './components/pages/BlogCategory';
import BlogEditor from './components/pages/BlogEditor';
import PageNotFound from './components/pages/PageNotFound';
import EmailSettings from './components/pages/EmailSettings';
import Profile from './components/pages/Profile';
import Temple from './components/pages/Temple';
import DeityPractice from './components/pages/DeityPractice';
import TempleAdmin from './components/pages/TempleAdmin';
import PracticePlayer from './components/temple/PracticePlayer';
import AdminLibrary from './components/pages/AdminLibrary';
import AdminAvatars from './components/pages/AdminAvatars';
import AdminContent from './components/pages/AdminContent';
import AdminBackups from './components/pages/AdminBackups';
import Learn from './components/pages/Learn';
import AmbientAudio from './components/AmbientAudio';
import Dharmadhara from './components/Dharmadhara';
import AdminDharmaMonitor from './components/pages/AdminDharmaMonitor';


const App = () => {
  return (
    <div className="App">
      <AmbientAudio />
      <Dharmadhara />
      <Navbar />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<Authenticate />} />
          <Route path="/library" element={<Library />} />
          <Route path="/library/mantras" element={<Mantras />} />
          <Route path="/library/sutras" element={<Sutras />} />
          <Route path="/library/sutras/:source/:id" element={<Sutras />} />
          <Route path="/library/works" element={<LibraryWorks />} />
          <Route path="/library/works/:id" element={<LibraryWork />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/post/:slug" element={<BlogPost />} />
          <Route path="/blog/:category" element={<BlogCategory />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/discord" element={<Discord />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/library" element={<AdminLibrary />} />
          <Route path="/admin/blog" element={<BlogEditor />} />
          <Route path="/admin/avatars" element={<AdminAvatars />} />
          <Route path="/admin/content" element={<AdminContent />} />
          <Route path="/admin/backups" element={<AdminBackups />} />
          <Route path="/admin/dharma-monitor" element={<AdminDharmaMonitor />} />
          <Route path="/email-settings" element={<EmailSettings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/temple" element={<Temple />} />
          <Route path="/temple/admin" element={<TempleAdmin />} />
          <Route path="/temple/:deityId" element={<DeityPractice />} />
          <Route path="/temple/:deityId/:practiceId" element={<PracticePlayer />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </div>
  )
}

export default App
